module.exports = __webpack_public_path__ + "static/af-b7494e9a9e5b04ff3c5432e625d0953d.svg";